<div class="tds-row">
    <div *ngIf="periodType === 'month'" class="tds-col-xxlg-2 tds-col-xlg-3 tds-col-lg-3 tds-col-md-4 tds-col-sm-6 tds-col-xs-12 tds-u-pb1">
        <tds-datetime 
            type="date"    
            size="sm" 
            class="tds-u-mb1"
            label="Select month(pick a date in a month)"
            [(ngModel)]="fromDate"  
            ngDefaultControl
            value="{{fromDate}}" 
            min="2023-01-01">
        </tds-datetime>     
    </div>

    <div *ngIf="periodType === 'week'" class="tds-col-xxlg-3 tds-col-xlg-4 tds-col-lg-4 tds-col-md-6 tds-col-sm-6 tds-col-xs-12">
        <tds-dropdown 
            name="dropdown" 
            label="Wweek" 
            label-position="outside" 
            placeholder="Select week" 
            size="sm" 
            class="tds-u-mb1"
            open-direction="auto"> 
            <tds-dropdown-option  *ngFor="let week of weekList" value="{{week.weekNo.toString()}}" (click)="selectWeek(week)">
                {{week.displayWeek}}
            </tds-dropdown-option> 
        </tds-dropdown>
    </div>        

    <div class="tds-col-xxlg-2 tds-col-xlg-3 tds-col-lg-3 tds-col-md-4 tds-col-sm-6 tds-col-xs-12">
        <tds-dropdown 
            name="dropdown" 
            label="Group" 
            label-position="outside" 
            placeholder="Select group" 
            size="sm" 
            class="tds-u-mb1"
            open-direction="auto"> 
            <tds-dropdown-option  *ngFor="let group of reportGroups" value="{{group.groupId.toString()}}" (click)="setSelectedGroup(group)">
                {{group.groupName}}
            </tds-dropdown-option> 
        </tds-dropdown>
    </div>        
    <div class="tds-col-xxlg-1 tds-col-xlg-1 tds-col-lg-2 tds-col-md-12 tds-col-sm-1 tds-col-xs-12 tds-u-pb12 tds-u-pt3">
        <tds-button [disabled]="isSubmitDisabled()"  type="button" variant="primary" size="sm" text="Search" (click)="getReportData()"> 
            <tds-icon slot="icon" size="20px" name="search"></tds-icon> 
        </tds-button>             
    </div>
</div>


<div *ngIf="dataSource" class="tds-col-md-12">
    <div *ngIf="reportGroups.length == 0" class="tds-col-md-12 tds-u-mb1 tds-u-mt1">
        <div class="tds-col-md-3"><strong>No report report group defined</strong>
            <br> Please add a report group and group persons in Group admin tab before user of this report
        </div>
    </div>
    
    <div *ngIf="dataSource.length == 0" class="tds-col-md-12 tds-u-mb1 tds-u-mt1">
        <div><strong>No data was found for user during the chosen period or query not run.</strong></div>
    </div>

    <div *ngIf="dataSource.length > 0" class="tds-col-md-12 tds-u-mb1 tds-u-mt1">
        <div class="tds-u-pt1">Report Total Hours: <strong>{{reportTotalHours}}</strong></div>
        <div class="tds-u-pt1">Row Count: <strong>{{rowCount}}</strong></div>
        <div class="tds-u-pt1" style="color: royalblue;">Showing data for status: TRANSFERRED</div>
        <div class="tds-u-pt1" style="color: firebrick;">Note that data older than 6 months is not available</div>
    </div>
    
    <tds-table vertical-dividers="false" 
        compact-design="true" 
        responsive="true" 
        no-min-width >
        <tds-table-header >
            <tds-header-cell cell-key="empName" sortable="true" cell-value="Name"></tds-header-cell>
            <tds-header-cell cell-key="projNo" sortable="true" cell-value="Project No"></tds-header-cell>
            <tds-header-cell cell-key="projName" sortable="true" cell-value="Project Name"></tds-header-cell>
            <tds-header-cell cell-key="taskNo" sortable="true" cell-value="Task No"> </tds-header-cell>
            <tds-header-cell cell-key="taskName" sortable="true" cell-value="Task Name"> </tds-header-cell>
            <tds-header-cell cell-key="expType" sortable="true" cell-value="Exp Type"> </tds-header-cell>
            <tds-header-cell cell-value="Hours" text-Align="right"></tds-header-cell>
        </tds-table-header>

        <tds-table-body >
            <tds-table-body-row *ngFor="let row of dataSource">
                <tds-body-cell>
                    <div class="tds-u-pt0" style="text-align: left;">
                        {{ row.empName }}
                    </div>
                </tds-body-cell>

                <tds-body-cell>
                    <div class="tds-u-pt0" style="text-align: left;">
                        {{ row.projNo }}
                    </div>
                </tds-body-cell>

                <tds-body-cell>
                    <div class="tds-u-pt0" style="text-align: left;">
                        {{ row.projName }}
                    </div>
                </tds-body-cell>
    
                <tds-body-cell>
                    <div class="tds-u-pt0" style="text-align: left;">
                        {{ row.taskNo }}
                    </div>
                </tds-body-cell>

                <tds-body-cell>
                    <div class="tds-u-pt0" style="text-align: left;">
                        {{ row.taskName }}
                    </div>
                </tds-body-cell>

                <tds-body-cell>
                    <div *ngIf="row.isSubTotalRow" class="subTotal" style="text-align: left;">
                        {{ row.expType }}
                    </div>
                    <div *ngIf="!row.isSubTotalRow" class="tds-u-pt0" style="text-align: left;">
                        {{ row.expType }}
                    </div>
                </tds-body-cell>

                <tds-body-cell>
                    <div *ngIf="row.isSubTotalRow" class="tds-u-pr1 subTotal" style="text-align: rigth;">
                        {{ row.hours.toFixed(1) }}
                    </div>
                    <div *ngIf="!row.isSubTotalRow" class="tds-u-pt0 tds-u-pr1" style="text-align: rigth;">
                        {{ row.hours.toFixed(1) }}
                    </div>
                </tds-body-cell>
            </tds-table-body-row>
        </tds-table-body >
    </tds-table>
</div>
    